import PropTypes from "prop-types";

/*
 * Tones map onto themeV2 Badge statuses, so colour comes from the design
 * tokens rather than this module. Every chip pairs its tone with an icon and a
 * label, so colour is reinforcement and never the sole channel (WCAG 1.4.1).
 */
export const BADGE_STATUS = Object.freeze({
  success: "success",
  neutral: "unavailable",
  info: "primary",
  warning: "pending",
  critical: "critical",
});

export const badgeStatusOf = (tone) => BADGE_STATUS[tone] ?? "unavailable";

export const tonePropType = PropTypes.oneOf(Object.keys(BADGE_STATUS));

export const statRowShape = PropTypes.shape({
  label: PropTypes.string.isRequired,
  value: PropTypes.string.isRequired,
  hint: PropTypes.string,
  tone: tonePropType,
});
